


import { Component, Vue, Inject, Watch } from 'vue-property-decorator'
import Oidc from 'oidc-client'
import tokenCofig from '@/lib/tokenCofig'
import Ajax from '@/lib/ajax'
import AppConsts from '@/lib/appconst'
import Util from '@/lib/util'
const mgr = new Oidc.UserManager(tokenCofig)

@Component({
  components: {},
})
export default class Login extends Vue {
  created() {}

  init() {
    let name = this.$route.name
    switch (name) {
      case 'login':
        this.loginFn()
        break
      case 'callback':
        this.loginCallbackFn()
        break
      case 'logout':
        this.logoutFn()
        break
    }
  }

  /**
   * 登录
   */
  loginFn() {
    mgr.signinRedirect()
  }

  /**
   * 登录重定向
   */
  loginCallbackFn() {
    let vm = this
    mgr
      .signinRedirectCallback()
      .then((res) => {
        if (res.access_token) {
          localStorage.setItem('id_token', res.id_token)
          localStorage.setItem('access_token', res.access_token)
          // localStorage.setItem('isRefresh', 'true')
          Ajax.get(`/api/abp/application-configuration`, {
            baseURL: AppConsts.token_root,
          }).then((res) => {
            console.log('logincallback', res);
            Util.extend(
              true,
              Util.abp.auth.allPermissions,
              res.data.auth.policies
            )
            Util.extend(
              true,
              Util.abp.auth.grantedPermissions,
              res.data.auth.grantedPolicies
            )
            vm.$router.replace({
              name: 'main',
            })
          })
        }
      })
      .catch((e) => {})
  }

  /**
   * 退出登录
   */
  logoutFn() {
    let vm = this
    mgr
      .signoutRedirectCallback(tokenCofig.post_logout_redirect_uri)
      .then((res) => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('isRefresh')
        Object.keys(localStorage).forEach(
          (item) =>
            item.indexOf('oidc.') != -1 ? localStorage.removeItem(item) : ''
        )
        Object.keys(sessionStorage).forEach(
          (item) =>
            item.indexOf('oidc.') != -1 ? sessionStorage.removeItem(item) : ''
        )
        vm.$router.push({
          name: 'login',
        })
      })
  }

  @Watch('$route', {
    immediate: true,
  })
  routeWatch() {
    this.init()
  }
}
